<template>
  <div class="w-100">
    <s-crud
      @returnObject="refresh($event)"
      no-border
      title="Aprobación de Proveedores de Materia Prima"
      :config="config"
      @save="saveDed($event)"
      @clearForm="clearForm()"
      @addEvent="clearForm()"
      @activePrd="clearForm()"
      @add="clearForm()"
      @EditEvent="editEvent()"
      @rowSelected="rowSelected($event)"
      add
      :edit="canEdit"
      :remove="canRemove"
      :filter="filter"
      height="400"
    >
      <template v-slot:filter>
        <v-container class="pa-2 mt-2 mb-2">
          <v-row dense>
            <v-col cols="12" md="4" lg="2">
              <s-date
                clearable
                v-model="filter.BeginDate"
                label="Fecha Inicio"
              ></s-date>
            </v-col>
            <v-col cols="12" md="4" lg="2">
              <s-date
                clearable
                v-model="filter.EndDate"
                label="Fecha Fin"
              ></s-date>
            </v-col>
            <v-col cols="12" md="4" lg="3">
              <s-select-campaign-area
                clearable
                no-default
                typeArea="1"
                v-model="filter.CmaID"
                label="Campaña"
              ></s-select-campaign-area>
            </v-col>
            <v-col cols="12" md="4" lg="3">
              <s-select-definition
                clearable
                :def="1753"
                v-model="filter.typeStatusApprovals"
                label="Tipo de Aprobación"
              ></s-select-definition>
            </v-col>
          </v-row>

          <v-row dense class="mt-0">
            <v-col cols="12" md="4" lg="3">
              <s-select-lot
                label="Sub Lote"
                v-model="filter.FltID"
                clearable
                full
                noDefault
              />
            </v-col>
            <v-col cols="12" md="4" lg="3">
              <s-select-producer
                clearable
                v-model="filter.PrdID"
                label="Productor"
              ></s-select-producer>
            </v-col>
            <v-col cols="12" md="4" lg="3">
              <s-select-definition
                clearable
                :def="1750"
                v-model="filter.TypeDestination"
                label="Destino"
              ></s-select-definition>
            </v-col>
          </v-row>
        </v-container>
      </template>
      <template scope="props">
        <v-container
          style="padding-top: 0px"
          v-if="props.item != null && syncFormState(props.item)"
          class="pb-0 mt-3"
        >
          <!-- Fila 1: Datos de Campaña, Lote y Productor -->
          <v-row dense class="mb-1">
            <v-col lg="3" md="4" sm="6" cols="12" class="s-col-form">
              <s-select-campaign-area
                no-default
                typeArea="1"
                v-model="props.item.CmaID"
                :disabled="props.item.typeStatusApprovals == 2"
                label="Campaña"
              ></s-select-campaign-area>
            </v-col>
            <v-col lg="2" md="4" sm="6" cols="12" class="s-col-form d-flex align-center">
              <s-search-lot-by-cod-senasa
                v-model="props.item.FltID"
                :disabled="props.item.typeStatusApprovals == 2"
                @searchSenasa="searchSenasa($event, props.item)"
                class="flex-grow-1"
              />
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    small
                    color="primary"
                    class="ml-1 mt-1"
                    v-bind="attrs"
                    v-on="on"
                    :disabled="props.item.typeStatusApprovals == 2"
                    @click="openHarvestLotsModal(props.item)"
                  >
                    <v-icon>mdi-calendar-multiselect</v-icon>
                  </v-btn>
                </template>
                <span>Seleccionar Lote de Programación de Cosecha</span>
              </v-tooltip>
            </v-col>
            <v-col lg="2" md="4" sm="6" cols="12" class="s-col-form">
              <s-text
                readonly
                label="Lote"
                v-model="props.item.FltName"
              ></s-text>
            </v-col>
            <v-col lg="2" md="4" sm="6" cols="12" class="s-col-form">
              <s-text
                readonly
                label="Fundo"
                v-model="props.item.FagName"
              ></s-text>
            </v-col>
            <v-col lg="3" md="8" sm="12" cols="12" class="s-col-form">
              <s-text
                readonly
                label="Productor"
                v-model="props.item.ProducerName"
              ></s-text>
            </v-col>
          </v-row>

          <!-- Fila 2: Destino, Documentación Completada y Observación -->
          <v-row dense class="mb-2 align-center">
            <v-col lg="3" md="4" sm="6" cols="12" class="s-col-form">
              <s-select-definition
                label="Destino"
                :def="1750"
                v-model="props.item.TypeDestination"
                :disabled="props.item.typeStatusApprovals == 2"
                clearable
              ></s-select-definition>
            </v-col>
            <v-col lg="6" md="4" cols="12" class="s-col-form">
              <s-text
                label="Observación"
                v-model="props.item.Observation"
                :disabled="props.item.typeStatusApprovals == 2"
                placeholder="Observación o nota del registro de documentos..."
              ></s-text>
            </v-col>
            <v-col lg="3" md="4" sm="6" cols="12" class="s-col-form pt-2">
              <s-switch
                label="Documentación Completada"
                v-model="props.item.DocumentationCompleted"
                :true-value="1"
                :false-value="0"
                color="primary"
                :disabled="props.item.typeStatusApprovals == 2"
              ></s-switch>
            </v-col>
          </v-row>

          <!-- Fila 3: Zona de Adjuntos -->
          <v-row dense>
            <v-col cols="12" class="mt-1">
              <div class="d-flex align-center justify-space-between mb-2">
                <span
                  class="text-subtitle-1 font-weight-bold grey--text text--darken-3"
                >
                  <v-icon left small color="primary">mdi-paperclip</v-icon>
                  Archivos Adjuntos
                </span>
                <v-chip
                  v-if="attachList.length > 0"
                  x-small
                  color="blue lighten-5"
                  class="blue--text text--darken-2 font-weight-medium"
                >
                  {{ attachList.length }}
                  {{ attachList.length === 1 ? "archivo" : "archivos" }}
                </v-chip>
              </div>

              <!-- Zona de Dropzone (Solo si NO está aprobado) -->
              <div
                v-if="props.item.typeStatusApprovals != 2"
                class="dropzone-container mb-4 text-center pa-6 rounded-lg"
                @dragover.prevent="dragover = true"
                @dragleave.prevent="dragover = false"
                @drop.prevent="onDrop"
                @click="triggerFilePicker"
                :class="{ 'dropzone-active': dragover }"
              >
                <div
                  class="dropzone-content d-flex flex-column align-center justify-center"
                >
                  <v-avatar
                    color="blue lighten-5"
                    size="60"
                    class="mb-3 dropzone-icon-wrapper"
                  >
                    <v-icon size="32" color="blue darken-2">
                      {{
                        dragover
                          ? "mdi-cloud-download"
                          : "mdi-cloud-upload-outline"
                      }}
                    </v-icon>
                  </v-avatar>

                  <div
                    class="text-subtitle-1 font-weight-bold grey--text text--darken-3 mb-1"
                  >
                    {{
                      dragover
                        ? "¡Suelta los archivos aquí!"
                        : "Arrastra y suelta tus archivos aquí"
                    }}
                  </div>

                  <div class="text-caption grey--text text--darken-1 mb-3">
                    o haz clic en cualquier parte de este recuadro para seleccionar desde tu equipo
                  </div>

                  <v-btn
                    color="blue darken-2"
                    outlined
                    small
                    class="text-capitalize px-4 rounded-pill font-weight-medium"
                    @click.stop="triggerFilePicker"
                  >
                    <v-icon left small>mdi-folder-open-outline</v-icon>
                    Buscar Archivos
                  </v-btn>
                </div>
              </div>

              <!-- Mensaje informativo cuando está Aprobado -->
              <v-alert
                v-else
                dense
                text
                type="info"
                class="mb-4 text-caption rounded-lg"
                color="blue darken-2"
              >
                <div class="d-flex align-center">
                  <v-icon color="blue darken-2" class="mr-2">mdi-lock</v-icon>
                  <span class="font-weight-medium">
                    Este registro se encuentra <strong>APROBADO</strong>. La carga y eliminación de archivos ha sido bloqueada.
                  </span>
                </div>
              </v-alert>

              <!-- Inputs de archivo ocultos fuera de la zona dropzone para evitar propagación de click -->
              <input
                type="file"
                ref="fileInput"
                multiple
                style="display: none"
                @change="handleNativeFileInput"
              />
              <input
                type="file"
                ref="replaceFileInput"
                style="display: none"
                @change="handleReplaceFileInput"
              />

              <div class="attach-table-wrapper">
                <v-data-table
                  :headers="
                    props.item.typeStatusApprovals == 2
                      ? attachHeaders.filter((h) => h.value !== 'actions')
                      : attachHeaders
                  "
                  :items="attachList"
                  dense
                  hide-default-footer
                  :items-per-page="-1"
                  no-data-text="No se han agregado archivos aún"
                  class="elevation-0"
                >
                  <template v-slot:item.fileName="{ item }">
                    <a
                      href="#"
                      @click.prevent="abrirVisorDocumento(item)"
                      style="
                        text-decoration: underline;
                        color: #1976d2;
                        max-width: 220px;
                      "
                      v-if="
                        item.fileName &&
                        item.fileName.toLowerCase().endsWith('.pdf')
                      "
                      class="text-caption text-truncate d-inline-block"
                    >
                      <v-icon small color="red">mdi-file-pdf-box</v-icon>
                      {{ item.fileName }}
                    </a>
                    <span
                      v-else-if="item.fileName"
                      class="text-caption text-truncate d-inline-block"
                      style="max-width: 220px"
                    >
                      <v-icon small color="grey"
                        >mdi-file-document-outline</v-icon
                      >
                      {{ item.fileName }}
                    </span>
                  </template>
                  <template v-slot:item.typeStatusApprovals="{ item }">
                    <v-chip
                      x-small
                      v-if="item.status === 'pendiente' && !item.isReplaced && (!item.SaaID || item.SaaID === 0)"
                      color="orange"
                      dark
                    >
                      Por Guardar
                    </v-chip>
                    <v-chip
                      x-small
                      v-else-if="item.isReplaced"
                      color="purple darken-1"
                      dark
                    >
                      <v-icon x-small left>mdi-file-check-outline</v-icon>
                      Subsanado (Por Guardar)
                    </v-chip>
                    <v-chip
                      x-small
                      v-else
                      :color="
                        item.typeStatusApprovals == 2
                          ? 'success'
                          : item.typeStatusApprovals == 3
                          ? 'error'
                          : item.typeStatusApprovals == 4
                          ? 'purple darken-1'
                          : 'warning'
                      "
                      dark
                    >
                      <v-icon x-small left v-if="item.typeStatusApprovals == 3">
                        mdi-alert-circle
                      </v-icon>
                      <v-icon x-small left v-else-if="item.typeStatusApprovals == 2">
                        mdi-check-circle
                      </v-icon>
                      <v-icon x-small left v-else-if="item.typeStatusApprovals == 4">
                        mdi-file-check-outline
                      </v-icon>
                      {{
                        item.typeStatusApprovals == 2
                          ? "Aprobado"
                          : item.typeStatusApprovals == 3
                          ? "Observado"
                          : item.typeStatusApprovals == 4
                          ? "Subsanado"
                          : "Pendiente"
                      }}
                    </v-chip>
                  </template>
                  <template v-slot:item.Observation="{ item }">
                    <span
                      v-if="item.Observation"
                      :class="
                        item.typeStatusApprovals == 3
                          ? 'red--text font-weight-medium text-caption'
                          : item.typeStatusApprovals == 4
                          ? 'purple--text text--darken-2 font-weight-medium text-caption'
                          : 'text-caption text-truncate d-inline-block'
                      "
                      style="max-width: 200px"
                      :title="item.Observation"
                    >
                      {{ item.Observation }}
                    </span>
                    <span v-else class="text-caption grey--text">-</span>
                  </template>
                  <template v-slot:item.download="{ item }">
                    <v-btn
                      icon
                      x-small
                      color="blue darken-2"
                      :disabled="item.status !== 'guardado'"
                      @click="openFile(item.fileName)"
                    >
                      <v-icon x-small>mdi-download</v-icon>
                    </v-btn>
                  </template>
                  <template v-slot:item.actions="{ item }">
                    <div class="d-flex align-center justify-center" v-if="props.item.typeStatusApprovals != 2">
                      <v-btn
                        v-if="(item.typeStatusApprovals == 3 || item.typeStatusApprovals == 4 || item.isReplaced) && item.typeStatusApprovals != 2"
                        icon
                        x-small
                        color="amber darken-3"
                        @click.stop="triggerReplaceFile(item)"
                        :title="item.isReplaced || item.typeStatusApprovals == 4 ? 'Cambiar archivo subsanado' : 'Subsanar / Reemplazar archivo observado'"
                        class="mr-1"
                      >
                        <v-icon x-small>mdi-file-replace-outline</v-icon>
                      </v-btn>
                      <v-btn
                        v-if="item.isReplaced"
                        icon
                        x-small
                        color="blue-grey"
                        @click.stop="cancelReplaceFile(item)"
                        title="Deshacer subsanación"
                        class="mr-1"
                      >
                        <v-icon x-small>mdi-undo</v-icon>
                      </v-btn>
                      <v-btn
                        v-if="item.typeStatusApprovals != 2"
                        icon
                        x-small
                        color="red lighten-1"
                        @click.stop="deleteAttachment(item)"
                        title="Eliminar archivo"
                      >
                        <v-icon x-small>mdi-delete</v-icon>
                      </v-btn>
                    </div>
                  </template>
                </v-data-table>
              </div>
            </v-col>
          </v-row>

          <!-- Fila 4: Zona de Análisis de Materia Prima Vinculados -->
          <v-row dense class="mt-4">
            <v-col cols="12">
              <div class="d-flex align-center justify-space-between mb-2">
                <div class="d-flex align-center">
                  <span class="text-subtitle-1 font-weight-bold grey--text text--darken-3">
                    <v-icon left small color="teal darken-2">mdi-flask</v-icon>
                    Análisis de Materia Prima Vinculados
                  </span>
                  <v-chip
                    v-if="selectedAnalysisList.length > 0"
                    x-small
                    color="teal lighten-5"
                    class="teal--text text--darken-3 font-weight-medium ml-2"
                  >
                    {{ selectedAnalysisList.length }}
                    {{ selectedAnalysisList.length === 1 ? "análisis" : "análisis" }}
                  </v-chip>
                </div>

                <v-btn
                  v-if="props.item.typeStatusApprovals != 2"
                  color="teal darken-2"
                  small
                  outlined
                  class="rounded-pill font-weight-medium text-capitalize"
                  @click="openAvailableAnalysisModal(props.item)"
                >
                  <v-icon left small>mdi-flask-plus</v-icon>
                  Seleccionar Análisis Disponibles
                </v-btn>
              </div>

              <!-- Tabla de Análisis Seleccionados en el Formulario -->
              <div class="elevation-1 rounded-lg overflow-hidden">
                <v-data-table
                  :headers="
                    props.item.typeStatusApprovals == 2
                      ? selectedAnalysisHeaders.filter((h) => h.value !== 'actions')
                      : selectedAnalysisHeaders
                  "
                  :items="selectedAnalysisList"
                  dense
                  hide-default-footer
                  :items-per-page="-1"
                  no-data-text="No se han vinculado análisis de materia prima para esta aprobación"
                  class="elevation-0"
                >
                  <template v-slot:item.ResultsIssueDate="{ item }">
                    <span>{{ item.ResultsIssueDate ? $moment(item.ResultsIssueDate).format("DD/MM/YYYY") : "-" }}</span>
                  </template>
                  <template v-slot:item.TypeStatusApprovalsName="{ item }">
                    <v-chip
                      x-small
                      :color="
                        item.TypeStatusApprovals == 2
                          ? 'success'
                          : item.TypeStatusApprovals == 3
                          ? 'error'
                          : item.TypeStatusApprovals == 4
                          ? 'purple darken-1'
                          : 'warning'
                      "
                      dark
                    >
                      {{ item.TypeStatusApprovalsName || 'PENDIENTE' }}
                    </v-chip>
                  </template>
                  <template v-slot:item.actions="{ item }">
                    <v-btn
                      v-if="props.item.typeStatusApprovals != 2"
                      icon
                      x-small
                      color="red lighten-1"
                      @click="removeSelectedAnalysis(item)"
                      title="Quitar análisis de esta aprobación"
                    >
                      <v-icon x-small>mdi-delete</v-icon>
                    </v-btn>
                  </template>
                </v-data-table>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </template>
      <!-- Columna de Adjuntos en el CRUD General -->
      <template v-slot:TotalCountAttachment="{ row }">
        <v-btn
          icon
          color="blue darken-2"
          @click="openViewAttachments(row)"
          title="Ver Archivos Adjuntos"
        >
          <v-badge
            :content="row.TotalCountAttachment"
            color="red"
            overlap
            v-if="row.TotalCountAttachment > 0"
          >
            <v-icon>mdi-paperclip</v-icon>
          </v-badge>
          <v-icon v-else>mdi-paperclip</v-icon>
        </v-btn>
      </template>

      <!-- Columna de Documentación Completada -->
      <template v-slot:DocumentationCompleted="{ row }">
        <v-chip
          x-small
          :color="row.DocumentationCompleted == 1 ? 'teal' : 'grey lighten-2'"
          :class="
            row.DocumentationCompleted == 1
              ? 'white--text font-weight-bold'
              : 'grey--text text--darken-2'
          "
        >
          <v-icon x-small left v-if="row.DocumentationCompleted == 1">
            mdi-check-bold
          </v-icon>
          {{ row.DocumentationCompleted == 1 ? "Completo" : "Incompleto" }}
        </v-chip>
      </template>

      <!-- Columna de Fecha Registro -->
      <template v-slot:DateRegister="{ row }">
        <span class="text-caption text-no-wrap">
          {{
            row.DateRegister
              ? $moment(row.DateRegister).format("DD/MM/YYYY")
              : "-"
          }}
        </span>
      </template>

      <!-- Columna de Observación (Registro) -->
      <template v-slot:Observation="{ row }">
        <span
          class="text-caption text-truncate d-inline-block"
          style="max-width: 150px"
          :title="row.Observation"
        >
          {{ row.Observation || '-' }}
        </span>
      </template>

      <!-- Columna de Observación de Confirmación -->
      <template v-slot:ObservationApproval="{ row }">
        <span
          class="text-caption text-truncate d-inline-block"
          style="max-width: 150px"
          :title="row.ObservationApproval"
        >
          {{ row.ObservationApproval || '-' }}
        </span>
      </template>

      <!-- Columna de Documentos Rechazados / Observados -->
      <template v-slot:CountRejectedAttachment="{ row }">
        <v-chip
          x-small
          :color="row.CountRejectedAttachment > 0 ? 'error' : 'grey lighten-2'"
          :class="
            row.CountRejectedAttachment > 0
              ? 'white--text font-weight-bold'
              : 'grey--text text--darken-2'
          "
          :title="row.CountRejectedAttachment > 0 ? 'Tiene ' + row.CountRejectedAttachment + ' documento(s) observado(s)' : 'Sin observaciones'"
        >
          <v-icon x-small left v-if="row.CountRejectedAttachment > 0">
            mdi-alert-circle
          </v-icon>
          {{ row.CountRejectedAttachment || 0 }}
        </v-chip>
      </template>

      <!-- Columna de Documentos Subsanados -->
      <template v-slot:CountSubsanadoAttachment="{ row }">
        <v-chip
          x-small
          :color="row.CountSubsanadoAttachment > 0 ? 'purple darken-1' : 'grey lighten-2'"
          :class="
            row.CountSubsanadoAttachment > 0
              ? 'white--text font-weight-bold'
              : 'grey--text text--darken-2'
          "
          :title="row.CountSubsanadoAttachment > 0 ? 'Tiene ' + row.CountSubsanadoAttachment + ' documento(s) subsanado(s)' : 'Sin subsanaciones'"
        >
          <v-icon x-small left v-if="row.CountSubsanadoAttachment > 0">
            mdi-file-check-outline
          </v-icon>
          {{ row.CountSubsanadoAttachment || 0 }}
        </v-chip>
      </template>

      <template v-slot:typeStatusApprovalsName="{ row }">
        <v-chip
          style="margin: 0px"
          x-small
          :color="getSupplierStatusColor(row)"
          dark
          :title="getSupplierStatusTitle(row)"
        >
          <v-icon x-small left v-if="getSupplierStatusIcon(row)">
            {{ getSupplierStatusIcon(row) }}
          </v-icon>
          {{ getSupplierStatusText(row) }}
        </v-chip>
      </template>
      <template v-slot:DateApproval="{ row }">
        <span class="text-caption text-no-wrap">
          {{
            row.DateApproval
              ? $moment(row.DateApproval).format("DD/MM/YYYY HH:mm")
              : "-"
          }}
        </span>
      </template>

      <!-- Columna de Requiere Análisis -->
      <template v-slot:RequiresAnalysis="{ row }">
        <v-chip
          x-small
          :color="row.RequiresAnalysis === 1 ? 'teal darken-1' : 'grey lighten-2'"
          :text-color="row.RequiresAnalysis === 1 ? 'white' : 'grey darken-2'"
          class="font-weight-medium"
          :title="
            row.ObservationAnalysis
              ? `Req. Análisis: ${row.ObservationAnalysis}`
              : row.RequiresAnalysis === 1
              ? 'Requiere Análisis de Materia Prima'
              : 'No Requiere'
          "
        >
          <v-icon x-small left v-if="row.RequiresAnalysis === 1">mdi-flask</v-icon>
          {{ row.RequiresAnalysis === 1 ? "Sí" : "No" }}
        </v-chip>
      </template>

      <!-- Columna de Observación de Análisis -->
      <template v-slot:ObservationAnalysis="{ row }">
        <span
          class="text-caption text-truncate d-inline-block"
          style="max-width: 150px"
          :title="row.ObservationAnalysis"
        >
          {{ row.ObservationAnalysis || '-' }}
        </span>
      </template>
    </s-crud>

    <!-- ========================================== -->
    <!-- MODAL DE ARCHIVOS ADJUNTOS CON TABS        -->
    <!-- ========================================== -->
    <v-dialog v-model="dialogAttachmentsModal" max-width="950px">
      <v-card class="rounded-lg">
        <v-card-title class="headline grey lighten-2 py-2 px-4">
          <div class="d-flex align-center">
            <v-icon color="blue darken-2" class="mr-2">mdi-folder-multiple-outline</v-icon>
            <span style="color: #333; font-weight: 600; font-size: 1.05rem">
              Archivos Adjuntos y Análisis
            </span>
          </div>
          <v-spacer></v-spacer>
          <v-btn icon small @click="dialogAttachmentsModal = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <!-- Información de cabecera del registro actual -->
        <div
          class="px-4 pt-3 pb-1 grey lighten-4 d-flex flex-wrap align-center"
          v-if="currentModalRow"
        >
          <span class="text-caption mr-4">
            <b>Campaña:</b> {{ currentModalRow.CmaName || '-' }}
          </span>
          <span class="text-caption mr-4">
            <b>Lote:</b> {{ currentModalRow.FltName || '-' }}
          </span>
          <span class="text-caption mr-4">
            <b>Fundo:</b> {{ currentModalRow.FagName || '-' }}
          </span>
          <span class="text-caption">
            <b>Productor:</b> {{ currentModalRow.ProducerName || '-' }}
          </span>
        </div>

        <v-card-text class="pa-4">
          <!-- Pestañas dentro del Modal -->
          <v-tabs
            v-model="modalActiveTab"
            background-color="grey lighten-3"
            color="blue darken-2"
            slider-color="blue darken-2"
            dense
            class="mb-3 rounded"
          >
            <v-tab class="text-capitalize font-weight-medium">
              <v-icon left small>mdi-account-details-outline</v-icon>
              Documentos de Proveedor ({{ modalAttachList.length }})
            </v-tab>
            <v-tab class="text-capitalize font-weight-medium">
              <v-icon left small>mdi-flask-outline</v-icon>
              Análisis de Materia Prima ({{ analysisAttachList.length }})
            </v-tab>
          </v-tabs>

          <v-tabs-items v-model="modalActiveTab">
            <!-- ============================================== -->
            <!-- SUB-TAB 1: DOCUMENTOS DE PROVEEDOR             -->
            <!-- ============================================== -->
            <v-tab-item>
              <div class="attach-table-wrapper">
                <v-data-table
                  :headers="modalAttachHeaders"
                  :items="modalAttachList"
                  dense
                  hide-default-footer
                  :items-per-page="-1"
                  no-data-text="No se han encontrado archivos adjuntos de proveedor"
                  class="elevation-0"
                >
                  <template v-slot:item.fileName="{ item }">
                    <a
                      href="#"
                      @click.prevent="abrirVisorDocumento(item)"
                      style="
                        text-decoration: underline;
                        color: #1976d2;
                        max-width: 250px;
                      "
                      v-if="
                        item.fileName &&
                        item.fileName.toLowerCase().endsWith('.pdf')
                      "
                      class="text-caption text-truncate d-inline-block"
                    >
                      <v-icon small color="red">mdi-file-pdf-box</v-icon>
                      {{ item.fileName }}
                    </a>
                    <span
                      v-else-if="item.fileName"
                      class="text-caption text-truncate d-inline-block"
                      style="max-width: 250px"
                    >
                      <v-icon small color="grey">mdi-file-document-outline</v-icon>
                      {{ item.fileName }}
                    </span>
                  </template>

                  <template v-slot:item.typeStatusApprovals="{ item }">
                    <v-chip
                      x-small
                      :color="
                        item.typeStatusApprovals == 2
                          ? 'success'
                          : item.typeStatusApprovals == 3
                          ? 'error'
                          : item.typeStatusApprovals == 4
                          ? 'purple darken-1'
                          : 'warning'
                      "
                      dark
                    >
                      <v-icon x-small left v-if="item.typeStatusApprovals == 3">
                        mdi-alert-circle
                      </v-icon>
                      <v-icon x-small left v-else-if="item.typeStatusApprovals == 2">
                        mdi-check-circle
                      </v-icon>
                      <v-icon x-small left v-else-if="item.typeStatusApprovals == 4">
                        mdi-file-check-outline
                      </v-icon>
                      {{
                        item.typeStatusApprovals == 2
                          ? 'Aprobado'
                          : item.typeStatusApprovals == 3
                          ? 'Observado'
                          : item.typeStatusApprovals == 4
                          ? 'Subsanado'
                          : 'Pendiente'
                      }}
                    </v-chip>
                  </template>

                  <template v-slot:item.Observation="{ item }">
                    <span
                      class="text-caption text-truncate d-inline-block"
                      style="max-width: 220px"
                      :title="item.Observation"
                      :class="
                        item.typeStatusApprovals == 3
                          ? 'red--text font-weight-medium'
                          : item.typeStatusApprovals == 4
                          ? 'purple--text text--darken-2 font-weight-medium'
                          : ''
                      "
                    >
                      {{ item.Observation || '-' }}
                    </span>
                  </template>

                  <template v-slot:item.download="{ item }">
                    <v-btn
                      icon
                      x-small
                      color="blue darken-2"
                      @click="openFile(item.fileName)"
                      title="Descargar archivo"
                    >
                      <v-icon x-small>mdi-download</v-icon>
                    </v-btn>
                  </template>
                </v-data-table>
              </div>
            </v-tab-item>

            <!-- ============================================== -->
            <!-- SUB-TAB 2: ANÁLISIS DE MATERIA PRIMA           -->
            <!-- ============================================== -->
            <v-tab-item>
              <div class="attach-table-wrapper">
                <v-data-table
                  :headers="modalAnalysisHeaders"
                  :items="analysisAttachList"
                  :loading="analysisLoading"
                  dense
                  hide-default-footer
                  :items-per-page="-1"
                  no-data-text="No se encontraron análisis de materia prima para este lote"
                  class="elevation-0"
                >
                  <template v-slot:item.fileName="{ item }">
                    <a
                      href="#"
                      @click.prevent="abrirVisorDocumento(item)"
                      style="
                        text-decoration: underline;
                        color: #1976d2;
                        max-width: 250px;
                      "
                      v-if="
                        item.fileName &&
                        item.fileName.toLowerCase().endsWith('.pdf')
                      "
                      class="text-caption text-truncate d-inline-block"
                    >
                      <v-icon small color="red">mdi-file-pdf-box</v-icon>
                      {{ item.fileName }}
                    </a>
                    <span
                      v-else-if="item.fileName && item.fileName !== '-'"
                      class="text-caption text-truncate d-inline-block"
                      style="max-width: 250px"
                    >
                      <v-icon small color="grey">mdi-file-document-outline</v-icon>
                      {{ item.fileName }}
                    </span>
                    <span v-else class="text-caption grey--text">
                      <v-icon x-small color="grey">mdi-file-remove-outline</v-icon>
                      Sin archivo
                    </span>
                  </template>

                  <template v-slot:item.typeStatusApprovals="{ item }">
                    <v-chip
                      x-small
                      :color="
                        item.typeStatusApprovals == 2
                          ? 'success'
                          : item.typeStatusApprovals == 3
                          ? 'error'
                          : item.typeStatusApprovals == 4
                          ? 'purple darken-1'
                          : 'warning'
                      "
                      dark
                    >
                      <v-icon x-small left v-if="item.typeStatusApprovals == 3">
                        mdi-alert-circle
                      </v-icon>
                      <v-icon x-small left v-else-if="item.typeStatusApprovals == 2">
                        mdi-check-circle
                      </v-icon>
                      <v-icon x-small left v-else-if="item.typeStatusApprovals == 4">
                        mdi-file-check-outline
                      </v-icon>
                      {{
                        item.typeStatusApprovals == 2
                          ? 'Aprobado'
                          : item.typeStatusApprovals == 3
                          ? 'Observado'
                          : item.typeStatusApprovals == 4
                          ? 'Subsanado'
                          : 'Pendiente'
                      }}
                    </v-chip>
                  </template>

                  <template v-slot:item.Observation="{ item }">
                    <span
                      class="text-caption text-truncate d-inline-block"
                      style="max-width: 220px"
                      :title="item.Observation"
                      :class="
                        item.typeStatusApprovals == 3
                          ? 'red--text font-weight-medium'
                          : item.typeStatusApprovals == 4
                          ? 'purple--text text--darken-2 font-weight-medium'
                          : ''
                      "
                    >
                      {{ item.Observation || '-' }}
                    </span>
                  </template>

                  <template v-slot:item.download="{ item }">
                    <v-btn
                      v-if="item.fileName && item.fileName !== '-'"
                      icon
                      x-small
                      color="blue darken-2"
                      @click="openFile(item.fileName)"
                      title="Descargar archivo"
                    >
                      <v-icon x-small>mdi-download</v-icon>
                    </v-btn>
                    <span v-else class="text-caption grey--text">-</span>
                  </template>
                </v-data-table>
              </div>
            </v-tab-item>
          </v-tabs-items>
        </v-card-text>

        <v-divider></v-divider>
        <v-card-actions class="pa-3">
          <v-spacer></v-spacer>
          <v-btn text small color="grey darken-1" @click="dialogAttachmentsModal = false">
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Modal Visor PDF -->
    <v-dialog v-model="visorDocumentoVisible" max-width="95%" persistent>
      <v-card class="rounded-lg">
        <v-card-title class="headline grey lighten-2">
          <span
            style="color: #333; font-weight: 600; font-size: 1.1rem"
            class="text-truncate"
          >
            Visor de Documento:
            {{ documentoActual ? documentoActual.fileName : "" }}
          </span>
          <v-spacer></v-spacer>

          <v-btn icon @click="visorDocumentoVisible = false"
            ><v-icon>mdi-close</v-icon></v-btn
          >
        </v-card-title>
        <v-card-text style="height: 80vh; padding: 0">
          <iframe
            v-if="pdfLocalPath"
            :src="pdfLocalPath"
            width="100%"
            height="100%"
            style="border: none; background-color: #f8fafc"
          ></iframe>
          <v-container v-if="descargandoDocumento" fill-height>
            <v-row align="center" justify="center">
              <v-col class="text-center">
                <v-progress-circular
                  indeterminate
                  color="primary"
                  size="64"
                ></v-progress-circular>
                <p class="mt-4 text--secondary">Cargando documento...</p>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Modal Selección de Lotes de Programación de Cosecha -->
    <v-dialog v-model="dialogHarvestLots" max-width="950px" scrollable>
      <v-card class="rounded-lg">
        <v-card-title class="headline grey lighten-2 pa-3">
          <span style="color: #333; font-weight: 600; font-size: 1.1rem">
            <v-icon left color="primary">mdi-calendar-multiselect</v-icon>
            Lotes de Programación de Cosecha
          </span>
          <v-spacer></v-spacer>
          <v-btn icon small @click="dialogHarvestLots = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pa-4">
          <v-row dense class="mb-2">
            <v-col cols="12">
              <v-text-field
                v-model="searchHarvestLot"
                append-icon="mdi-magnify"
                label="Buscar por Lote, Fundo, Productor o Fecha..."
                single-line
                hide-details
                outlined
                dense
                clearable
              ></v-text-field>
            </v-col>
          </v-row>

          <v-data-table
            :headers="harvestLotHeaders"
            :items="harvestLotsList"
            :search="searchHarvestLot"
            :loading="loadingHarvestLots"
            loading-text="Cargando lotes de programación..."
            no-data-text="No se encontraron lotes de programación para esta campaña"
            dense
            :items-per-page="10"
            class="elevation-1"
          >
            <template v-slot:item.HvsDate="{ item }">
              <span>{{ item.HvsDateFormatted || formatHarvestDate(item.HvsDate) }}</span>
            </template>
            <template v-slot:item.action="{ item }">
              <v-btn
                color="primary"
                x-small
                depressed
                @click="selectHarvestLot(item)"
              >
                <v-icon x-small left>mdi-check</v-icon>
                Seleccionar
              </v-btn>
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions class="pa-3 grey lighten-4">
          <v-spacer></v-spacer>
          <v-btn text small color="grey darken-1" @click="dialogHarvestLots = false">
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog para seleccionar Análisis de Materia Prima Disponibles -->
    <v-dialog v-model="dialogAvailableAnalysis" max-width="950px" scrollable>
      <v-card class="rounded-lg">
        <v-card-title class="pa-3 teal darken-2 white--text d-flex align-center justify-space-between">
          <div class="d-flex align-center">
            <v-icon left color="white">mdi-flask-outline</v-icon>
            <span class="text-subtitle-1 font-weight-bold">
              Seleccionar Análisis de Materia Prima Disponibles (Libres)
            </span>
          </div>
          <v-btn icon small dark @click="dialogAvailableAnalysis = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="pa-4">
          <v-row dense class="mb-2 align-center">
            <v-col cols="12" md="6">
              <v-text-field
                v-model="searchAvailableAnalysis"
                dense
                outlined
                hide-details
                prepend-inner-icon="mdi-magnify"
                label="Buscar por N° doc, tipo, matriz, estado..."
                clearable
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6" class="text-right">
              <span class="text-caption grey--text text--darken-2">
                {{ selectedAvailableAnalysis.length }} seleccionado(s) de {{ availableAnalysisList.length }} disponible(s)
              </span>
            </v-col>
          </v-row>

          <v-data-table
            v-model="selectedAvailableAnalysis"
            :headers="availableAnalysisHeaders"
            :items="availableAnalysisList"
            :search="searchAvailableAnalysis"
            :loading="loadingAvailableAnalysis"
            loading-text="Cargando análisis disponibles..."
            no-data-text="No se encontraron análisis libres para esta campaña y lote"
            dense
            show-select
            item-key="RmnID"
            :items-per-page="10"
            class="elevation-1"
          >
            <template v-slot:item.ResultsIssueDate="{ item }">
              <span>{{ item.ResultsIssueDate ? $moment(item.ResultsIssueDate).format("DD/MM/YYYY") : "-" }}</span>
            </template>
            <template v-slot:item.TypeStatusApprovalsName="{ item }">
              <v-chip
                x-small
                :color="
                  item.TypeStatusApprovals == 2
                    ? 'success'
                    : item.TypeStatusApprovals == 3
                    ? 'error'
                    : item.TypeStatusApprovals == 4
                    ? 'purple darken-1'
                    : 'warning'
                "
                dark
              >
                {{ item.TypeStatusApprovalsName || 'PENDIENTE' }}
              </v-chip>
            </template>
          </v-data-table>
        </v-card-text>

        <v-card-actions class="pa-3 grey lighten-4 d-flex justify-space-between">
          <v-btn text small color="grey darken-1" @click="dialogAvailableAnalysis = false">
            Cancelar
          </v-btn>
          <v-btn
            color="teal darken-2"
            small
            depressed
            dark
            :disabled="selectedAvailableAnalysis.length === 0"
            @click="confirmSelectedAnalyses"
          >
            <v-icon small left>mdi-check</v-icon>
            Agregar Seleccionados ({{ selectedAvailableAnalysis.length }})
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import _sSupplierApprovalsService from "@/services/Technicalassistance/TasSupplierApprovalsService.js";
import _sAnalysisService from "@/services/Technicalassistance/TasRawMaterialAnalysisService.js";
import _sGeneral from "@/services/HelperService";
import SSearchLotByCodSenasa from "@/components/HarvestSchedule/sSearchLotByCodSenasa.vue";
import SSelectLot from "@/components/HarvestSchedule/SSelectLot.vue";
import SSelectCampaignArea from "@/components/Utils/SSelectCampaignArea.vue";
import SSelectProducer from "@/components/HarvestSchedule/SSelectProducer";

export default {
  components: {
    SSearchLotByCodSenasa,
    SSelectLot,
    SSelectCampaignArea,
    SSelectProducer,
  },
  data: () => ({
    filter: {
      SecStatus: 0,
      BeginDate: null,
      EndDate: null,
      CmaID: null,
      FltID: null,
      PrdID: null,
      typeStatusApprovals: null,
      FagName: null,
      TypeDestination: null,
    },
    selected: [],
    dragover: false,
    attachList: [],
    deletedAttachList: [],
    attachForm: {
      files: [],
    },
    currentFormSuaID: null,
    // Modal PDF
    visorDocumentoVisible: false,
    pdfLocalPath: null,
    documentoActual: null,
    descargandoDocumento: false,
    attachHeaders: [
      { text: "Archivo", value: "fileName", sortable: false },
      { text: "Tamaño", value: "fileSize", sortable: false, width: 85 },
      {
        text: "Estado",
        value: "typeStatusApprovals",
        sortable: false,
        width: 110,
        align: "center",
      },
      {
        text: "Observación",
        value: "Observation",
        sortable: false,
        width: 180,
      },
      {
        text: "Descargar",
        value: "download",
        sortable: false,
        width: 70,
        align: "center",
      },
      {
        text: "",
        value: "actions",
        sortable: false,
        width: 80,
        align: "center",
      },
    ],
    replaceTargetItem: null,
    // Modal Adjuntos (General con Tabs)
    dialogAttachmentsModal: false,
    modalActiveTab: 0,
    currentModalRow: null,
    modalAttachList: [],
    modalAttachHeaders: [
      { text: "Archivo", value: "fileName", sortable: false },
      {
        text: "Estado Adjunto",
        value: "typeStatusApprovals",
        sortable: false,
        width: 110,
        align: "center",
      },
      { text: "Observación", value: "Observation", sortable: false, width: 220 },
      {
        text: "Descargar",
        value: "download",
        sortable: false,
        width: 70,
        align: "center",
      },
    ],
    analysisLoading: false,
    analysisAttachList: [],
    modalAnalysisHeaders: [
      { text: "N° Documento", value: "RmnDocumentNumber", sortable: false, width: 110 },
      { text: "Tipo Análisis", value: "TypeAnalysisName", sortable: false, width: 130 },
      { text: "Matriz", value: "TypeMatrixName", sortable: false, width: 100 },
      { text: "Archivo", value: "fileName", sortable: false },
      {
        text: "Estado",
        value: "typeStatusApprovals",
        sortable: false,
        width: 110,
        align: "center",
      },
      { text: "Observación", value: "Observation", sortable: false, width: 200 },
      {
        text: "Descargar",
        value: "download",
        sortable: false,
        width: 70,
        align: "center",
      },
    ],
    // Modal Lotes de Programación de Cosecha
    dialogHarvestLots: false,
    loadingHarvestLots: false,
    searchHarvestLot: "",
    harvestLotsList: [],
    targetFormRow: null,
    harvestLotHeaders: [
      { text: "ID Lote", value: "FltID", width: "90", sortable: true },
      { text: "Fecha", value: "HvsDate", width: "105", sortable: true },
      { text: "Lote", value: "FltName", sortable: true },
      { text: "Fundo", value: "FagName", sortable: true },
      { text: "Productor", value: "ProducerName", sortable: true },
      { text: "Acción", value: "action", width: "110", sortable: false, align: "center" },
    ],
    // Gestión de Análisis de Materia Prima en Formulario
    selectedAnalysisList: [],
    deletedAnalysisList: [],
    dialogAvailableAnalysis: false,
    loadingAvailableAnalysis: false,
    searchAvailableAnalysis: "",
    availableAnalysisList: [],
    selectedAvailableAnalysis: [],
    selectedAnalysisHeaders: [
      { text: "N° Documento", value: "RmnDocumentNumber", width: 140 },
      { text: "Tipo Análisis", value: "TypeAnalysisName", width: 150 },
      { text: "Matriz", value: "TypeMatrixName", width: 130 },
      { text: "Estado Aprobación", value: "TypeStatusApprovalsName", width: 140 },
      { text: "Fecha Emisión", value: "ResultsIssueDate", width: 120 },
      { text: "Acciones", value: "actions", sortable: false, width: 80, align: "center" },
    ],
    availableAnalysisHeaders: [
      { text: "N° Documento", value: "RmnDocumentNumber", width: 140 },
      { text: "Tipo Análisis", value: "TypeAnalysisName", width: 150 },
      { text: "Matriz", value: "TypeMatrixName", width: 130 },
      { text: "Estado Aprobación", value: "TypeStatusApprovalsName", width: 140 },
      { text: "Fecha Emisión", value: "ResultsIssueDate", width: 120 },
      { text: "Sub Lote", value: "FltName", width: 130 },
    ],
    config: {
      title: "Aprobación de Proveedores",
      service: _sSupplierApprovalsService,
      model: {
        SuaID: "ID",
        DateRegister: "date",
        SecStatus: "status",
        TypeDestination: "int",
        RequiresAnalysis: "int",
        ObservationAnalysis: "string",
        TasSupplierApprovalsAttachment: [],
      },
      headers: [
        {
          text: "ID",
          value: "SuaID",
          width: "55",
          align: "center",
          sortable: true,
        },
        {
          text: "Fecha Registro",
          value: "DateRegister",
          width: "110",
          sortable: true,
          align: "center",
        },
        {
          text: "Lote",
          value: "FltID",
          width: "85",
          sortable: true,
          align: "center",
        },
        {
          text: "Campaña",
          value: "CmaName",
          width: "140",
          sortable: true,
        },
        {
          text: "Productor",
          value: "ProducerName",
          width: "220",
          sortable: true,
        },
        {
          text: "Fundo",
          value: "FagName",
          width: "190",
          sortable: true,
        },
        {
          text: "Doc. Completa",
          value: "DocumentationCompleted",
          width: "115",
          sortable: true,
          align: "center",
        },
        {
          text: "Adjuntos",
          value: "TotalCountAttachment",
          width: "80",
          sortable: true,
          align: "center",
        },
        {
          text: "Observados",
          value: "CountRejectedAttachment",
          width: "95",
          sortable: true,
          align: "center",
        },
        {
          text: "Subsanados",
          value: "CountSubsanadoAttachment",
          width: "95",
          sortable: true,
          align: "center",
        },
        {
          text: "Tipo Aprobación",
          value: "typeStatusApprovalsName",
          width: "170",
          sortable: true,
          align: "center",
        },
        {
          text: "Req. Análisis",
          value: "RequiresAnalysis",
          width: "105",
          sortable: true,
          align: "center",
        },
        {
          text: "Obs. Registro",
          value: "Observation",
          width: "160",
          sortable: true,
        },
        {
          text: "Obs. Análisis",
          value: "ObservationAnalysis",
          width: "160",
          sortable: true,
        },
        {
          text: "Obs. Confirmación",
          value: "ObservationApproval",
          width: "160",
          sortable: true,
        },
        {
          text: "Usuario Confirmación",
          value: "UsrIDApprovalName",
          width: "180",
          sortable: true,
        },
        {
          text: "Fecha Confirmación",
          value: "DateApproval",
          width: "145",
          sortable: true,
          align: "center",
        },
      ],
    },
  }),
  computed: {
    canEdit() {
      return (
        !this.selected ||
        this.selected.length === 0 ||
        this.selected[0].typeStatusApprovals != 2
      );
    },
    canRemove() {
      return (
        !this.selected ||
        this.selected.length === 0 ||
        this.selected[0].typeStatusApprovals != 2
      );
    },
  },
  created() {
    const today = this.$moment().format("YYYY-MM-DD");
    this.filter.BeginDate = today;
    this.filter.EndDate = today;
  },
  beforeDestroy() {
    if (this.pdfLocalPath) {
      URL.revokeObjectURL(this.pdfLocalPath);
    }
  },
  methods: {
    syncFormState(item) {
      if (!item) return false;
      const suaId = item.SuaID ? Number(item.SuaID) : 0;
      if (this.currentFormSuaID !== suaId) {
        this.currentFormSuaID = suaId;
        if (suaId === 0) {
          this.clearForm();
        }
      }
      return true;
    },
    refresh(item) {
      this.currentFormSuaID = null;
      this.clearForm();
      this.$emit("refresh", item);
    },
    rowSelected(item) {
      this.selected = item;
      if (!item || item.length === 0) {
        this.currentFormSuaID = null;
        this.clearForm();
      }
    },
    clearForm() {
      this.attachList = [];
      this.deletedAttachList = [];
      this.selectedAnalysisList = [];
      this.deletedAnalysisList = [];
      this.availableAnalysisList = [];
      this.selectedAvailableAnalysis = [];
      this.attachForm.files = [];
      this.replaceTargetItem = null;
      if (this.$refs.fileInput) {
        this.$refs.fileInput.value = "";
      }
      if (this.$refs.replaceFileInput) {
        this.$refs.replaceFileInput.value = "";
      }
    },
    async editEvent() {
      if (this.selected && this.selected.length > 0) {
        const item = this.selected[0];
        this.currentFormSuaID = item.SuaID ? Number(item.SuaID) : 0;
        this.attachList = [];
        this.deletedAttachList = [];
        this.selectedAnalysisList = [];
        this.deletedAnalysisList = [];
        try {
          const [resAtt, resMat] = await Promise.all([
            _sSupplierApprovalsService.AttachmentList(
              item.SuaID,
              this.$fun.getUserID()
            ),
            _sSupplierApprovalsService.MaterialAnalysisList(
              item.SuaID,
              this.$fun.getUserID()
            ),
          ]);
          if (resAtt && resAtt.status === 200) {
            let list = Array.isArray(resAtt.data) ? resAtt.data : resAtt.data.data || [];
            this.attachList = list.map((item) => ({
              SaaID: item.SaaID || item.saaID || 0,
              SuaID: item.SuaID || item.suaID || 0,
              fileName: item.FilePath || item.filePath,
              typeStatusApprovals:
                item.TypeStatusApprovals || item.typeStatusApprovals || 1,
              typeStatusApprovalsName:
                item.TypeStatusApprovalsName ||
                item.typeStatusApprovalsName ||
                (item.TypeStatusApprovals == 4
                  ? 'SUBSANADO'
                  : item.TypeStatusApprovals == 3
                  ? 'OBSERVADO'
                  : item.TypeStatusApprovals == 2
                  ? 'APROBADO'
                  : 'PENDIENTE'),
              Observation: item.Observation || item.observation || '',
              DateApproval: item.DateApproval || item.dateApproval || null,
              UsrIDApprovalName: item.UsrIDApprovalName || item.usrIDApprovalName || '',
              fileSize: "-",
              status: "guardado",
            }));
          }
          if (resMat && resMat.status === 200) {
            let matList = Array.isArray(resMat.data) ? resMat.data : resMat.data.data || [];
            this.selectedAnalysisList = matList.map((m) => ({
              SmaID: m.SmaID || m.smaID || 0,
              SuaID: m.SuaID || m.suaID || item.SuaID,
              RmnID: m.RmnID || m.rmnID || 0,
              RmnDocumentNumber: m.RmnDocumentNumber || m.rmnDocumentNumber || "-",
              TypeAnalysisName: m.TypeAnalysisName || m.typeAnalysisName || "-",
              TypeMatrixName: m.TypeMatrixName || m.typeMatrixName || "-",
              TypeStatusApprovals: m.TypeStatusApprovals || m.typeStatusApprovals || 1,
              TypeStatusApprovalsName: m.TypeStatusApprovalsName || m.typeStatusApprovalsName || "PENDIENTE",
              ResultsIssueDate: m.ResultsIssueDate || m.resultsIssueDate || null,
              FltName: m.FltName || m.fltName || "-",
            }));
          }
        } catch (e) {
          console.log("Error fetching attachments or analyses", e);
        }
      }
    },
    async openViewAttachments(row) {
      this.currentModalRow = row;
      this.modalAttachList = [];
      this.analysisAttachList = [];
      this.modalActiveTab = 0;
      this.dialogAttachmentsModal = true;
      await Promise.all([
        this.fetchSupplierAttachments(row),
        this.fetchAnalysisAttachments(row),
      ]);
    },
    async fetchSupplierAttachments(row) {
      try {
        const res = await _sSupplierApprovalsService.AttachmentList(
          row.SuaID,
          this.$fun.getUserID()
        );
        if (res.status === 200) {
          let list = Array.isArray(res.data) ? res.data : res.data.data || [];
          this.modalAttachList = list.map((item) => ({
            SaaID: item.SaaID || item.saaID || 0,
            SuaID: item.SuaID || item.suaID || 0,
            fileName: item.FilePath || item.filePath,
            typeStatusApprovals:
              item.TypeStatusApprovals || item.typeStatusApprovals || 1,
            typeStatusApprovalsName:
              item.TypeStatusApprovalsName ||
              item.typeStatusApprovalsName ||
              (item.TypeStatusApprovals == 4
                ? 'SUBSANADO'
                : item.TypeStatusApprovals == 3
                ? 'OBSERVADO'
                : item.TypeStatusApprovals == 2
                ? 'APROBADO'
                : 'PENDIENTE'),
            DateApproval: item.DateApproval || item.dateApproval || null,
            UsrIDApprovalName: item.UsrIDApprovalName || item.usrIDApprovalName || '',
            Observation: item.Observation || item.observation || '',
            fileSize: "-",
            status: "guardado",
          }));
        }
      } catch (e) {
        console.error("Error fetching supplier attachments", e);
      }
    },
    async fetchAnalysisAttachments(row) {
      this.analysisLoading = true;
      try {
        let linkedAnalyses = [];
        if (row.SuaID && row.SuaID > 0) {
          const resLinked = await _sSupplierApprovalsService.MaterialAnalysisList(
            row.SuaID,
            this.$fun.getUserID()
          );
          if (resLinked && resLinked.status === 200) {
            linkedAnalyses = Array.isArray(resLinked.data) ? resLinked.data : resLinked.data.data || [];
          }
        }

        // Si existen análisis vinculados a esta aprobación, traemos sus documentos por detalle (AttachmentList por RmnID)
        if (linkedAnalyses.length > 0) {
          const detailedPromises = linkedAnalyses.map(async (analysis) => {
            try {
              const resAtt = await _sAnalysisService.AttachmentList(
                analysis.RmnID,
                this.$fun.getUserID()
              );
              if (resAtt && resAtt.status === 200) {
                const attachments = Array.isArray(resAtt.data) ? resAtt.data : resAtt.data.data || [];
                if (attachments.length > 0) {
                  return attachments.map((att) => ({
                    RmaID: att.RmaID || att.rmaID || 0,
                    RmnID: analysis.RmnID,
                    fileName: att.FilePath || att.filePath,
                    typeStatusApprovals:
                      att.TypeStatusApprovals || att.typeStatusApprovals || analysis.TypeStatusApprovals || 1,
                    typeStatusApprovalsName:
                      att.TypeStatusApprovalsName ||
                      att.typeStatusApprovalsName ||
                      analysis.TypeStatusApprovalsName ||
                      (att.TypeStatusApprovals == 4
                        ? "SUBSANADO"
                        : att.TypeStatusApprovals == 3
                        ? "OBSERVADO"
                        : att.TypeStatusApprovals == 2
                        ? "APROBADO"
                        : "PENDIENTE"),
                    Observation: att.Observation || att.observation || analysis.Observation || "",
                    DateApproval: att.DateApproval || att.dateApproval || null,
                    UsrApprovalName: att.UsrApprovalName || att.usrApprovalName || "",
                    CmaName: att.CmaName || analysis.CmaName || row.CmaName || "-",
                    FltName: att.FltName || analysis.FltName || row.FltName || "-",
                    FagName: att.FagName || analysis.FagName || row.FagName || "-",
                    PrdCardName: att.PrdCardName || analysis.PrdCardName || row.ProducerName || "-",
                    RmnDocumentNumber: att.RmnDocumentNumber || analysis.RmnDocumentNumber || "-",
                    TypeAnalysisName: att.TypeAnalysisName || analysis.TypeAnalysisName || "-",
                    TypeMatrixName: att.TypeMatrixName || analysis.TypeMatrixName || "-",
                    status: "guardado",
                  }));
                }
              }
            } catch (err) {
              console.error(`Error loading attachments for RmnID ${analysis.RmnID}`, err);
            }

            // Si el análisis no tiene archivos adjuntos en TasRawMaterialAnalysisAttachment, mostramos la fila informativa
            return [{
              RmaID: 0,
              RmnID: analysis.RmnID,
              fileName: null,
              typeStatusApprovals: analysis.TypeStatusApprovals || 1,
              typeStatusApprovalsName: analysis.TypeStatusApprovalsName || "PENDIENTE",
              Observation: analysis.Observation || "",
              DateApproval: analysis.DateApproval || null,
              UsrApprovalName: analysis.UsrApprovalName || "",
              CmaName: analysis.CmaName || row.CmaName || "-",
              FltName: analysis.FltName || row.FltName || "-",
              FagName: analysis.FagName || row.FagName || "-",
              PrdCardName: analysis.PrdCardName || row.ProducerName || "-",
              RmnDocumentNumber: analysis.RmnDocumentNumber || "-",
              TypeAnalysisName: analysis.TypeAnalysisName || "-",
              TypeMatrixName: analysis.TypeMatrixName || "-",
              status: "guardado",
            }];
          });

          const results = await Promise.all(detailedPromises);
          this.analysisAttachList = results.flat();
        } else {
          // Fallback para registros sin análisis vinculados: consultar por lote y campaña
          const res = await _sAnalysisService.AttachmentApprovalList(
            row.CmaID || 0,
            row.FltID || 0,
            this.$fun.getUserID()
          );
          if (res && res.status === 200) {
            let list = Array.isArray(res.data) ? res.data : res.data.data || [];
            this.analysisAttachList = list.map((item) => ({
              RmaID: item.RmaID || item.rmaID || 0,
              RmnID: item.RmnID || item.rmnID || 0,
              fileName: item.FilePath || item.filePath,
              typeStatusApprovals:
                item.TypeStatusApprovals || item.typeStatusApprovals || 1,
              typeStatusApprovalsName:
                item.TypeStatusApprovalsName ||
                item.typeStatusApprovalsName ||
                (item.TypeStatusApprovals == 4
                  ? "SUBSANADO"
                  : item.TypeStatusApprovals == 3
                  ? "OBSERVADO"
                  : item.TypeStatusApprovals == 2
                  ? "APROBADO"
                  : "PENDIENTE"),
              Observation: item.Observation || item.observation || "",
              DateApproval: item.DateApproval || item.dateApproval || null,
              UsrApprovalName: item.UsrApprovalName || item.usrApprovalName || "",
              CmaName: item.CmaName || item.cmaName || "-",
              FltName: item.FltName || item.fltName || "-",
              FagName: item.FagName || item.fagName || "-",
              PrdCardName: item.PrdCardName || item.prdCardName || "-",
              RmnDocumentNumber: item.RmnDocumentNumber || item.rmnDocumentNumber || "-",
              TypeAnalysisName: item.TypeAnalysisName || item.typeAnalysisName || "-",
              TypeMatrixName: item.TypeMatrixName || item.typeMatrixName || "-",
              status: "guardado",
            }));
          } else {
            this.analysisAttachList = [];
          }
        }
      } catch (e) {
        console.error("Error fetching analysis attachments", e);
        this.analysisAttachList = [];
      } finally {
        this.analysisLoading = false;
      }
    },
    async saveDed(item) {
      if (item.typeStatusApprovals == 2) {
        this.$fun.alert(
          "El registro ya se encuentra aprobado y no puede ser modificado.",
          "warning"
        );
        return;
      }
      const pending = this.attachList.filter((x) => x.status === "pendiente");
      if (pending.length > 0) {
        const formData = new FormData();
        pending.forEach((row, index) => {
          formData.append(index.toString(), row.file);
        });

        try {
          const uploadRes = await _sGeneral.uploadfile(
            "SupplierApprovals",
            this.$fun.getUserID(),
            formData,
            3,
          );
          if (uploadRes.status !== 200) {
            this.$fun.alert("Error al subir los archivos físicos", "warning");
            return;
          }
        } catch (e) {
          console.error(e);
          this.$fun.alert("Error al subir los archivos físicos", "warning");
          return;
        }
      }

      const validAttachments = this.attachList.map((a) => ({
        SaaID: a.SaaID || 0,
        SuaID: item.SuaID || 0,
        FilePath: a.fileName,
        TypeStatusApprovals: a.typeStatusApprovals || (a.isReplaced ? 4 : 1),
        Observation: a.Observation || null,
        SecStatus: 1,
        UsrCreateID: this.$fun.getUserID(),
      }));

      const deletedAttachments = this.deletedAttachList.map((a) => ({
        SaaID: a.SaaID || 0,
        SuaID: item.SuaID || 0,
        FilePath: a.fileName,
        SecStatus: 0,
        UsrCreateID: this.$fun.getUserID(),
      }));

      item.TasSupplierApprovalsAttachment = [
        ...validAttachments,
        ...deletedAttachments,
      ];

      // Vincular análisis de materia prima a la gestión documentaria
      const validAnalyses = (this.selectedAnalysisList || []).map((a) => ({
        SmaID: a.SmaID || 0,
        SuaID: item.SuaID || 0,
        RmnID: a.RmnID,
        SecStatus: 1,
        UsrCreateID: this.$fun.getUserID(),
      }));

      const deletedAnalyses = (this.deletedAnalysisList || []).map((a) => ({
        SmaID: a.SmaID || 0,
        SuaID: item.SuaID || 0,
        RmnID: a.RmnID,
        SecStatus: 0,
        UsrCreateID: this.$fun.getUserID(),
        UsrUpdateID: this.$fun.getUserID(),
      }));

      item.TasSupplierApprovalsMaterialAnalysis = [
        ...validAnalyses,
        ...deletedAnalyses,
      ];

      item.UsrCreateID = this.$fun.getUserID();

      item.save();
    },
    searchSenasa(item, row) {
      if (item) {
        row.FltID = item.FltID;
        this.$set(row, "FagName", item.FagName);
        this.$set(row, "FltName", item.FltName);
        this.$set(row, "ProducerName", item.PrdCardName || item.ProducerName);
      }
    },
    formatHarvestDate(date) {
      if (!date) return "-";
      if (this.moment && this.moment(date).isValid()) {
        return this.moment(date).format("DD/MM/YYYY");
      }
      return this.$fun && this.$fun.formatDateView ? this.$fun.formatDateView(date) : date;
    },
    async openHarvestLotsModal(row) {
      if (!row || !row.CmaID) {
        this.$fun.alert("Seleccione una campaña primero", "warning");
        return;
      }
      this.targetFormRow = row;
      this.searchHarvestLot = "";
      this.harvestLotsList = [];
      this.dialogHarvestLots = true;
      this.loadingHarvestLots = true;

      try {
        const res = await _sSupplierApprovalsService.HarvestScheduleLots(
          row.CmaID,
          this.$fun.getUserID()
        );
        if (res.status === 200) {
          const data = Array.isArray(res.data) ? res.data : (res.data && res.data.data) || [];
          this.harvestLotsList = data.map((item) => {
            const hvsDate = item.HvsDate || item.hvsDate || null;
            return {
              ...item,
              HvsDate: hvsDate,
              HvsDateFormatted: this.formatHarvestDate(hvsDate),
              ProducerName: item.ProducerName || item.PrdCardName || item.PrdName || "",
            };
          });
        } else {
          this.$fun.alert("No se pudieron obtener los lotes de la programación", "warning");
        }
      } catch (error) {
        console.error("Error al obtener lotes de programación de cosecha:", error);
        this.$fun.alert("Error al cargar los lotes de programación", "error");
      } finally {
        this.loadingHarvestLots = false;
      }
    },
    selectHarvestLot(item) {
      if (this.targetFormRow) {
        this.targetFormRow.FltID = item.FltID;
        this.$set(this.targetFormRow, "FagName", item.FagName);
        this.$set(this.targetFormRow, "FltName", item.FltName);
        const producer = item.ProducerName || item.PrdCardName || item.PrdName || "";
        this.$set(this.targetFormRow, "ProducerName", producer);
        if (item.HvsDate) {
          this.$set(this.targetFormRow, "HvsDate", item.HvsDate);
        }
        if (item.TypeDestination != null) {
          this.$set(this.targetFormRow, "TypeDestination", item.TypeDestination);
        }
      }
      this.dialogHarvestLots = false;
      this.$fun.alert(`Lote "${item.FltName || item.FltID}" seleccionado correctamente`, "success");
    },
    async openAvailableAnalysisModal(row) {
      if (!row || !row.CmaID) {
        this.$fun.alert("Seleccione una campaña primero", "warning");
        return;
      }
      this.loadingAvailableAnalysis = true;
      this.dialogAvailableAnalysis = true;
      this.searchAvailableAnalysis = "";
      this.selectedAvailableAnalysis = [];
      this.availableAnalysisList = [];
      try {
        const res = await _sSupplierApprovalsService.AvailableMaterialAnalysisList(
          row.CmaID,
          row.FltID || 0,
          row.SuaID || 0,
          this.$fun.getUserID()
        );
        if (res && res.status === 200) {
          let list = Array.isArray(res.data) ? res.data : res.data.data || [];
          const currentRmnIds = new Set(this.selectedAnalysisList.map((x) => x.RmnID));
          this.availableAnalysisList = list.filter((x) => !currentRmnIds.has(x.RmnID));
        }
      } catch (e) {
        console.error("Error fetching available material analysis", e);
        this.$fun.alert("Error al cargar análisis disponibles", "error");
      } finally {
        this.loadingAvailableAnalysis = false;
      }
    },
    confirmSelectedAnalyses() {
      if (this.selectedAvailableAnalysis && this.selectedAvailableAnalysis.length > 0) {
        const currentRmnIds = new Set(this.selectedAnalysisList.map((x) => x.RmnID));
        const toAdd = this.selectedAvailableAnalysis
          .filter((x) => !currentRmnIds.has(x.RmnID))
          .map((x) => ({
            SmaID: 0,
            SuaID: this.currentFormSuaID || 0,
            RmnID: x.RmnID,
            RmnDocumentNumber: x.RmnDocumentNumber || "-",
            TypeAnalysisName: x.TypeAnalysisName || "-",
            TypeMatrixName: x.TypeMatrixName || "-",
            TypeStatusApprovals: x.TypeStatusApprovals || 1,
            TypeStatusApprovalsName: x.TypeStatusApprovalsName || "PENDIENTE",
            ResultsIssueDate: x.ResultsIssueDate || null,
            FltName: x.FltName || "-",
          }));
        this.selectedAnalysisList.push(...toAdd);
        this.$fun.alert(`${toAdd.length} análisis vinculado(s) al formulario`, "success");
      }
      this.dialogAvailableAnalysis = false;
      this.selectedAvailableAnalysis = [];
    },
    removeSelectedAnalysis(item) {
      if (item.SmaID && item.SmaID > 0) {
        this.deletedAnalysisList.push({
          ...item,
          SecStatus: 0,
        });
      }
      this.selectedAnalysisList = this.selectedAnalysisList.filter(
        (x) => x.RmnID !== item.RmnID
      );
    },
    searchSenasaFilter(item) {
      if (item) {
        this.filter.FltID = item.FltID;
        this.$set(this.filter, "FagName", item.FagName);
      } else {
        this.filter.FltID = null;
        this.$set(this.filter, "FagName", null);
      }
    },
    triggerFilePicker() {
      if (this.$refs.fileInput) {
        this.$refs.fileInput.click();
      }
    },
    triggerReplaceFile(item) {
      if (
        (this.selected.length > 0 && this.selected[0].typeStatusApprovals == 2) ||
        (item && item.typeStatusApprovals == 2)
      ) {
        this.$fun.alert(
          "El archivo o registro se encuentra aprobado y no puede ser modificado.",
          "warning"
        );
        return;
      }
      this.replaceTargetItem = item;
      if (this.$refs.replaceFileInput) {
        this.$refs.replaceFileInput.value = "";
        this.$refs.replaceFileInput.click();
      }
    },
    handleReplaceFileInput(e) {
      const file = e.target.files && e.target.files[0];
      if (!file) return;

      const target = this.replaceTargetItem;
      if (!target) return;

      const index = this.attachList.indexOf(target);
      if (index === -1) return;

      if (!target.isReplaced) {
        target.originalData = {
          fileName: target.fileName,
          fileSize: target.fileSize,
          typeStatusApprovals: target.typeStatusApprovals,
          typeStatusApprovalsName: target.typeStatusApprovalsName,
          status: target.status,
        };
      }

      target.file = file;
      target.fileName = file.name;
      target.fileSize = (file.size / 1024).toFixed(1) + " KB";
      target.status = "pendiente";
      target.typeStatusApprovals = 4;
      target.typeStatusApprovalsName = "SUBSANADO";
      target.isReplaced = true;
      // La observación se conserva tal cual

      this.$set(this.attachList, index, { ...target });
      this.replaceTargetItem = null;
      e.target.value = "";

      this.$fun.alert(
        "Archivo subsanado. Estado cambiado a Subsanado. Recuerde guardar los cambios.",
        "success"
      );
    },
    cancelReplaceFile(item) {
      const index = this.attachList.indexOf(item);
      if (index === -1) return;
      const target = this.attachList[index];
      if (target && target.originalData) {
        const restored = {
          ...target,
          ...target.originalData,
        };
        delete restored.originalData;
        delete restored.isReplaced;
        delete restored.file;
        this.$set(this.attachList, index, restored);
        this.$fun.alert("Reemplazo cancelado.", "info");
      }
    },
    handleNativeFileInput(e) {
      const files = Array.from(e.target.files || []);
      if (files.length > 0) {
        this.attachForm.files = files;
        this.addAttachToList();
      }
      e.target.value = "";
    },
    addAttachToList() {
      if (this.selected.length > 0 && this.selected[0].typeStatusApprovals == 2) {
        this.$fun.alert(
          "El registro está aprobado y no se pueden agregar archivos.",
          "warning"
        );
        return;
      }
      const { files } = this.attachForm;
      if (!files || files.length === 0) {
        this.$fun.alert("Seleccione al menos un archivo", "warning");
        return;
      }

      let duplicados = 0;
      files.forEach((file) => {
        const exists = this.attachList.some(
          (item) => item.fileName === file.name,
        );
        if (exists) {
          duplicados++;
          return;
        }

        const sizeKB = (file.size / 1024).toFixed(1);
        this.attachList.push({
          SaaID: 0,
          SuaID: 0,
          fileName: file.name,
          fileSize: sizeKB + " KB",
          file,
          status: "pendiente",
        });
      });

      if (duplicados > 0) {
        this.$fun.alert(
          `${duplicados} archivo(s) omitidos por estar duplicados.`,
          "info",
        );
      }
      this.attachForm.files = [];
    },
    async onDrop(e) {
      this.dragover = false;
      if (this.selected.length > 0 && this.selected[0].typeStatusApprovals == 2) {
        return;
      }
      const items = e.dataTransfer.items;

      if (items && items.length > 0) {
        const files = [];
        const promises = [];

        for (let i = 0; i < items.length; i++) {
          const item = items[i];
          if (item.kind === "file") {
            const entry = item.webkitGetAsEntry
              ? item.webkitGetAsEntry()
              : null;
            if (entry) {
              promises.push(this.traverseFileTree(entry, files));
            } else {
              files.push(item.getAsFile());
            }
          }
        }

        await Promise.all(promises);

        if (files.length > 0) {
          this.attachForm.files = files;
          this.addAttachToList();
        }
      } else if (e.dataTransfer.files.length > 0) {
        this.attachForm.files = Array.from(e.dataTransfer.files);
        this.addAttachToList();
      }
    },
    traverseFileTree(item, filesArr) {
      return new Promise((resolve) => {
        if (item.isFile) {
          item.file((file) => {
            filesArr.push(file);
            resolve();
          });
        } else if (item.isDirectory) {
          const dirReader = item.createReader();
          dirReader.readEntries(async (entries) => {
            const promises = [];
            for (let i = 0; i < entries.length; i++) {
              promises.push(this.traverseFileTree(entries[i], filesArr));
            }
            await Promise.all(promises);
            resolve();
          });
        } else {
          resolve();
        }
      });
    },
    async deleteAttachment(item) {
      const index = typeof item === "number" ? item : this.attachList.indexOf(item);
      if (index === -1) return;
      const attach = this.attachList[index];
      if (
        (this.selected.length > 0 && this.selected[0].typeStatusApprovals == 2) ||
        (attach && attach.typeStatusApprovals == 2)
      ) {
        this.$fun.alert(
          "El registro o archivo está aprobado y no se puede eliminar.",
          "warning"
        );
        return;
      }
      if (attach.status === "guardado" && attach.SaaID > 0) {
        const confirm = await this.$fun.alert(
          "¿Está seguro de eliminar este archivo adjunto?",
          "question",
        );
        if (!confirm.value) return;
        this.deletedAttachList.push(attach);
      }
      this.attachList.splice(index, 1);
    },
    openFile(nameFile) {
      _sGeneral.download(nameFile, this.$fun.getUserID()).then((r) => {
        if (r.status === 200) {
          this.$fun.download(r.data, nameFile);
        } else {
          this.$fun.alert("El archivo no se encuentra disponible", "warning");
        }
      });
    },
    async abrirVisorDocumento(item) {
      if (this.descargandoDocumento) return;
      if (item.status !== "guardado") {
        this.$fun.alert(
          "Debes guardar el registro primero para visualizar el PDF.",
          "warning",
        );
        return;
      }

      if (!item.fileName || !item.fileName.toLowerCase().endsWith(".pdf")) {
        this.$fun.alert(
          "El visor en línea solo soporta archivos PDF. Utilice el botón de descarga.",
          "info",
        );
        return;
      }

      if (this.pdfLocalPath) {
        URL.revokeObjectURL(this.pdfLocalPath);
        this.pdfLocalPath = null;
      }

      this.descargandoDocumento = true;
      this.documentoActual = item;
      this.visorDocumentoVisible = true;

      try {
        const response = await _sGeneral.download(
          item.fileName,
          this.$fun.getUserID(),
        );

        if (!response || !response.data) {
          throw new Error("El archivo no se encontró");
        }

        const blob = new Blob([response.data], { type: "application/pdf" });
        this.pdfLocalPath = URL.createObjectURL(blob);
      } catch (error) {
        this.$fun.alert(
          "El documento no está disponible en este momento.",
          "warning",
        );
        this.visorDocumentoVisible = false;
      } finally {
        this.descargandoDocumento = false;
      }
    },
    getSupplierStatusColor(row) {
      const statusNum = Number(row.typeStatusApprovals != null ? row.typeStatusApprovals : row.TypeStatusApprovals);
      const statusName = String(row.typeStatusApprovalsName || row.TypeStatusApprovalsName || "").toUpperCase().trim();

      if (statusNum === 6 || statusName === "SUBSANADO" || statusName.includes("SUBSANAD")) {
        return "purple darken-1";
      }
      if (statusNum === 2 || statusName === "APROBADO") {
        return "success";
      }
      if (statusNum === 3 || statusName === "OBSERVADO" || statusName.includes("OBSERVAD")) {
        return "amber darken-3";
      }
      if (statusNum === 4 || statusName === "RESTRINGIDO" || statusName.includes("RESTRING")) {
        return "orange darken-3";
      }
      if (statusNum === 5 || statusName === "NO CONFORME" || statusName.includes("NO CONFORME")) {
        return "error";
      }
      return "blue-grey darken-1";
    },
    getSupplierStatusIcon(row) {
      const statusNum = Number(row.typeStatusApprovals != null ? row.typeStatusApprovals : row.TypeStatusApprovals);
      const statusName = String(row.typeStatusApprovalsName || row.TypeStatusApprovalsName || "").toUpperCase().trim();

      if (statusNum === 6 || statusName === "SUBSANADO" || statusName.includes("SUBSANAD")) {
        return "mdi-file-check-outline";
      }
      if (statusNum === 2 || statusName === "APROBADO") {
        return "mdi-check-circle";
      }
      if (statusNum === 3 || statusName === "OBSERVADO" || statusName.includes("OBSERVAD")) {
        return "mdi-clock-alert-outline";
      }
      if (statusNum === 4 || statusName === "RESTRINGIDO" || statusName.includes("RESTRING")) {
        return "mdi-shield-alert-outline";
      }
      if (statusNum === 5 || statusName === "NO CONFORME" || statusName.includes("NO CONFORME")) {
        return "mdi-close-circle";
      }
      return "mdi-clock-outline";
    },
    getSupplierStatusText(row) {
      const statusNum = Number(row.typeStatusApprovals != null ? row.typeStatusApprovals : row.TypeStatusApprovals);
      const statusName = String(row.typeStatusApprovalsName || row.TypeStatusApprovalsName || "").toUpperCase().trim();

      if (statusNum === 6 || statusName === "SUBSANADO" || statusName.includes("SUBSANAD")) {
        return "SUBSANADO";
      }
      if (statusNum === 2 || statusName === "APROBADO") {
        return "APROBADO";
      }
      if (statusNum === 3 || statusName === "OBSERVADO" || statusName.includes("OBSERVAD")) {
        return "OBSERVADO";
      }
      if (statusNum === 4 || statusName === "RESTRINGIDO" || statusName.includes("RESTRING")) {
        return "RESTRINGUIDO";
      }
      if (statusNum === 5 || statusName === "NO CONFORME" || statusName.includes("NO CONFORME")) {
        return "NO CONFORME";
      }
      return row.typeStatusApprovalsName || row.TypeStatusApprovalsName || "PENDIENTE";
    },
    getSupplierStatusTitle(row) {
      const statusNum = Number(row.typeStatusApprovals != null ? row.typeStatusApprovals : row.TypeStatusApprovals);
      const statusName = String(row.typeStatusApprovalsName || row.TypeStatusApprovalsName || "").toUpperCase().trim();

      if (statusNum === 6 || statusName === "SUBSANADO" || statusName.includes("SUBSANAD")) {
        return "Documentación subsanada, pendiente de re-evaluación";
      }
      if (statusNum === 2 || statusName === "APROBADO") {
        return "Aprobado para todo destino";
      }
      if (statusNum === 3 || statusName === "OBSERVADO" || statusName.includes("OBSERVAD")) {
        return "Pendiente documentación u observado";
      }
      if (statusNum === 4 || statusName === "RESTRINGIDO" || statusName.includes("RESTRING")) {
        return "Conforme pero restricción de análisis";
      }
      if (statusNum === 5 || statusName === "NO CONFORME" || statusName.includes("NO CONFORME")) {
        return "No conforme, no es posible la descarga";
      }
      return "Aún por revisar";
    },
  },
};
</script>

<style scoped>
.dropzone-container {
  border: 2px dashed #90caf9;
  background-color: #f8fafc;
  cursor: pointer;
  transition: all 0.25s ease-in-out;
  position: relative;
  overflow: hidden;
}

.dropzone-container:hover {
  border-color: #1976d2;
  background-color: #f0f7ff;
  box-shadow: 0 4px 12px rgba(25, 118, 210, 0.08);
}

.dropzone-container:hover .dropzone-icon-wrapper {
  transform: translateY(-3px);
  background-color: #e3f2fd !important;
}

.dropzone-icon-wrapper {
  transition: transform 0.2s ease, background-color 0.2s ease;
}

.dropzone-active {
  border-color: #1565c0 !important;
  background-color: #e3f2fd !important;
  transform: scale(1.005);
  box-shadow: 0 6px 16px rgba(21, 101, 192, 0.15);
}

/* Evitar saltos de línea en celdas y cabeceras de la tabla principal */
::v-deep .v-data-table table th,
::v-deep .v-data-table table td {
  white-space: nowrap !important;
}
</style>
